<template>
  <div class="install">
    <h4 v-if="steps[step]">
      {{ partner.name }} -
      {{ step | setText(steps[step].title) }}
    </h4>
    <template v-for="(value, stepKey) in steps">
      <template v-if="step == stepKey">
        <component
          :createTransaction="createTransaction"
          :updateOrder="updateOrder"
          :transaction="transaction"
          :order="order"
          :partner="partner"
          :partner_id="partner_id"
          :is="stepKey"
          @setStep="setStep"
          :key="stepKey"
          v-model="body"
        />
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: "tbc",
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setStep(step = null) {
      if (!step) {
        this.$emit("close", true);
      } else {
        this.step = step;
      }
    },
  },
  watch: {},
  components: {
    processing: () => import("./processing"),
    done: () => import("./done"),
  },
  created() {
    try {
      if (
        this.transaction &&
        this.transaction.step &&
        this.steps[this.transaction.step]
      ) {
        this.step = this.transaction.step;
      }
    } catch (error) {}
  },
  computed: {},
  data() {
    return {
      body: null,
      step: "processing",
      steps: {
        processing: {
          title: "Процесс формирования",
        },
        done: {
          title: "Завершено",
        },
      },
    };
  },
};
</script>

